import { render } from "./IconYouTube.vue?vue&type=template&id=2cf3644c"
import script from "./IconYouTube.vue?vue&type=script&lang=js"
export * from "./IconYouTube.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__